import React,{useState} from "react";
import Typewriter from "typewriter-effect";
import styled from "styled-components";
import './title-message.css'
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';

const MyTitleMessage = styled.h1`
  position: absolute;
  width: 100%;
  top: 22rem;
  z-index: 1;
  margin-top: -125px;
  text-align: center;

  strong {
    font-size: 1.25em;
  }
  div {
    color: ${props => props.theme.textColor};

    text-shadow: 0px 2px 5px rgba(0, 0, 0, 0.4);
    font-weight: 100;
    letter-spacing: 7px;

    .main {
      font-size: 50px;
    }

    .sub {
      font-size: 27px;
      letter-spacing: 2px;
    }


  }
`;

const handleClick=e=>{
  window.scrollTo({
    top:window.innerHeight,
    left:"100",
    behavior: 'smooth'     
})
console.log(window.innerHeight/3)
}

const TitleMessage = () => (
  
  <>
  <MyTitleMessage>
    <div className="titleMessage" style={{left:window.innerWidth/2}}>
      <div className="heading">
        <div className="main text-center mb-3">
          Hi, I am
          <br />
          <span>
            <strong>Nishanth</strong>
          </span>
        </div>
        <div className="sub">
          <Typewriter
            options={{
              strings: ["Web Developer", "Student", "Learner"],
              autoStart: true,
              loop: true,
              delay: 60
            }}
          />
        </div>
    <button id="button" style={{top:window.innerHeight/4 }} onClick={handleClick}> 
   <ArrowDownwardIcon style={{ fontSize: 30 }} /> 
    </button>
      </div>
    </div>
  </MyTitleMessage>
  
  </>
);

export default TitleMessage;
